module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "gray-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.t_data.base.title))])]), _vm._v(" "), _c('div', {
    staticClass: "floor"
  }, [_c('img', {
    attrs: {
      "src": _vm.t_data.config.imgUrl,
      "alt": ""
    }
  })])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f20172ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f20172ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/custompage/components/plugins/imgHotzone/index.vue
// module id = 2978
// module chunks = 0